import React from 'react';

const cx = (...v) => v.filter(Boolean).join(' ');

export default function FormSection({ title, description, action = null, className = '', children }) {
  return (
    <section className={cx('cc-tonal-panel-soft p-4', className)}>
      {(title || action) && (
        <div className="mb-3 flex items-start justify-between gap-3">
          <div>
            {title ? <h3 className="text-sm font-semibold text-[#e7f0fa]">{title}</h3> : null}
            {description ? <p className="mt-0.5 text-xs text-[#8ea3bd]">{description}</p> : null}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}
